export default __webpack_public_path__ + "assets/front/scss/editorial.e31e537f8333f2b5779dc9c852fefe2c.css";